import './styles.css';

import { BaseGame, IEngineConfig, queryStringParams } from '@game-studio/arcade-base';

import packageConfig from '@/package.json';
import config from '@/config.json';
import { getBindings } from '@/src/core/inversify';
import { getAdditionalSettings } from '@/src/core/settings';
import { features } from '@/features';

export type SkinName = 'bankbonus';
const skin = queryStringParams.currentSkin as SkinName;
const region = queryStringParams.locale;

const recentWinnersName = region !== 'en-gb' ? queryStringParams.currentSkin : 'spin';

const engineConfig: IEngineConfig = {
    GameCategory: config.gameCategory,
    EngineName: config.engineName[region][skin],
    LoggingName: config.friendlyName,

    // The game name used in the call to the recent winners API.
    // Update this if the name needed differs from the game category name
    RecentWinnersName: recentWinnersName,

    Version: packageConfig.version,
    Features: features[region],
    HeightRatio: config.game.heightRatio,

    AdditionalSettingsGetter: getAdditionalSettings,
    GamePreferences: {},

    CdnFolderName: config.cdn.cdnFolderName,
};

const engine = new BaseGame();
const bindings = getBindings();
engine.initialise(engineConfig, bindings.gameBindings, bindings.regionBindings);